import { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Stack, Button, Paper, Box, LinearProgress } from '@mui/material';

// line liff
import liff from '@line/liff';

// hooks
// components
import UserService from '../services/user.service';
import { ROLES, staticProfile } from '../constants';
import Iconify from '../components/iconify/Iconify';
// sections
import { AppContext, isLocalhost } from '../App';


// const liff = window.liff
const liffId = '1656457313-YPyxmGdd' // process.env.REACT_APP_LIFF_ID; // isLocalhost ? '1657818347-OQA4wE9x'  //

function logOut() {
  liff.logout();
  // setSignedIn(false)
  // window.location.reload();
  window.location.replace([window.location.href,'/?time=',new Date().valueOf()].join(""))

}

// https://access.line.me/oauth2/v2.1/error400?error=Bad+Request&error_description=invalid+url.+channelId%3D1657818347%2C+redirectUriString%3Dhttp%3A%2F%2Flocalhost%3A3000%2Flogin
function logIn() {
  liff.login({ redirectUri: window.location.href });
}

async function getLineProfile() {
  const profile = await liff.getProfile();
  document.getElementById('pictureUrl').style.display = 'block';
  document.getElementById('pictureUrl').src = profile.pictureUrl;
  return profile;
}

async function getUser(userId) {
  //   const httpservice = new HTTPService();
  const user = await UserService.getUser(userId);
  return user;
}

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  // boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const navigate = useNavigate();
  const { setUser } = useContext(AppContext);
  const [signedIn, setSignedIn] = useState(false);
  const [UIReady, setUIReady] = useState(false);
  // const [log, setLog] = useState('');

  useEffect(() => {
    let user;
    if (isLocalhost) {
      setUIReady(true);
      (async () => {
        let profile = staticProfile;
        user = staticProfile // await getUser('Ua9c8f436d7e538689acdfa38cda3761e');
        if (user) profile = { ...user, ...profile };
        if (!profile.role) profile.role = 'user';
        setUser(profile);
      })();
      return undefined;
    }

    (async () => {
      if (isLocalhost) return;

      const viewcheckinroles = Object.entries(ROLES).filter(([, value]) => value.rights && value.rights.includes('viewcheckin')).map(([key,]) => key)
      await liff.init({ liffId });

      if (liff.isInClient()) {
        getLineProfile().then(async (data) => {
          // setLog(t => [t, 'got data'].join("\n"))
          // setLog(t => [t, JSON.stringify(data)].join("\n"))
          let profile = data;
          user = await getUser(data.userId);
          if (user) profile = { ...user, ...profile };
          if (!profile.role) profile.role = 'user';

          setUIReady(true);
          setUser(profile);
          setSignedIn(true);

          if (profile.role && viewcheckinroles.includes(profile.role)) {
            navigate('/dashboard/checkin');
          } 
          // else {
          //   navigate('/dashboard/userprofile');
          // }

          // navigate('/dashboard/default')
        });
      } else if (liff.isLoggedIn()) {
        getLineProfile().then(async (data) => {
          let profile = data;
          // setLog(t => [t, 'got data'].join("\n"))
          // setLog(t => [t, JSON.stringify(data)].join("\n"))

          setUIReady(true);

          user = await getUser(data.userId);
          if (user) {
            // setProfile(o => ({ ...o, ...profile }))

            // setLog(t => [t, 'got user'].join("\n"))
            // setLog(t => [t, JSON.stringify(user)].join("\n"))
            // if (!user.fullname) {
            //   navigate('/dashboard/userprofile');
            // } else {
            //   navigate('/dashboard/default');
            // }let profile = data;
          
            profile = { ...user, ...profile };
            if (!profile.role) profile.role = 'user';

            setUIReady(true);
            setUser(profile);
            setSignedIn(true);
            setUIReady(true);
            if (profile.role && viewcheckinroles.includes(profile.role)) {
              navigate('/dashboard/checkin');
            } 

          } else {
            navigate('/dashboard/userprofile/userinitiated')
          }
        });
      } else {
        // document.getElementById("lineloginbutton").style.display = "block"
        setUIReady(true);
        document.getElementById('btnLogOut').style.display = 'none';
      }
    })();

    return undefined;
  }, [navigate, setUser]);

  // const { error, isLoggedIn, isReady, liff } = useLiff();
  return (
    <>
      <StyledRoot>
        <StyledSection>
          <Typography variant="h3" sx={{ px: 5, mt: 0, mb: 0 }}>
            The Runway Operating System
          </Typography>
          <Paper style={{ height: 60 }} sx={{ px: 10, mt: 2, mb: 0 }}>
            <img src="/assets/images/runway/runway_banner2.png" alt="login" />
          </Paper>
          <Typography variant="h5" sx={{ px: 10, mt: 20, mb: 0 }}>
            ลงชื่อเข้าใช้งานระบบ
            <br />
          </Typography>
        </StyledSection>

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h6" gutterBottom>
              {'ลงชื่อเข้าใช้งานระบบ'}
            </Typography>
            {/* {hasGroup ? <></> : <Typography variant="body2" color={'warning'} sx={{ mb: 5 }}>
              {firstTimeInfo}
              </Typography>} */}            
            <Typography variant="body2" sx={{ mb: 5 }}>
              {signedIn || isLocalhost ? (
                <></>
              ) : (
                // <Link variant="h4" sx={{cursor: 'pointer'}} onClick={() => navigate("/dashboard/app")} >เริ่มต้นใช้งาน</Link>
                <>
                  หากยังไม่มีบัญชี {''} <Link variant="subtitle2">เข้าสู่ระบบเพื่อสร้างบัญชี</Link>
                </>
              )}
            </Typography>
            <Stack direction={{ sm: 'column', md: 'row' }} spacing={4}>
              <img
                id="pictureUrl"
                src={'/assets/images/runway/logo_logo_th.png'}
                style={{ maxWidth: 240, borderRadius: 10 }}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = 'https://flexitarmstrong.web.app/assets/images/runway/logo_logo_th.png';
                }}
                alt="line profile"
              />

              {signedIn || isLocalhost ? (
                <Stack direction="column" spacing={2}>
                  <Box sx={{ flexGrow: 1 }} />

                  <Button
                    id="btnLogOut"
                    color="success"
                    variant="contained"
                    onClick={() => navigate('/dashboard/checkin')}
                  >
                    เริ่มต้นใช้งาน
                  </Button>
                  {(liff.isInClient() || isLocalhost) && (
                    <Button
                      onClick={() => {
                        window.open(`https://flexitarmstrong.web.app/dashboard/app`);
                        liff.closeWindow();
                      }}
                      variant="contained"
                      startIcon={<Iconify icon="iconoir:open-in-browser" />}
                    >
                      เปิดบนเบราเซอร์
                    </Button>
                  )}

                  {liff.isInClient() && liff.isLoggedIn() ? (
                    <>เข้าสู่ระบบเรียบร้อย กำลังเปลี่ยนหน้า</>
                  ) : (
                    <Button id="btnLogOut" color="warning" variant="outlined" size="small" onClick={logOut}>
                      ออกจากระบบ
                    </Button>
                  )}
                  <Box sx={{ flexGrow: 1 }} />
                </Stack>
              ) : (
                // <Link variant="h4" sx={{cursor: 'pointer'}} onClick={() => navigate("/dashboard/app")} >เริ่มต้นใช้งาน</Link>
                  <Stack direction="column" spacing={2}>
                    <Button color="inherit" onClick={logIn}>
                      <img src={'/assets/images/btn_login_base.png'} alt="line login button" width={'100%'} />
                    </Button>
                    <Button id="btnLogOut" color='warning' variant='outlined' size='small' onClick={logOut}>ออกจากระบบ</Button>
                  </Stack>
              )}

              {/* <Button fullWidth size="large" color="inherit" variant="outlined">
              <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />
            </Button>

            <Button fullWidth size="large" color="inherit" variant="outlined">
              <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />
            </Button>

            <Button fullWidth size="large" color="inherit" variant="outlined">
              <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />
            </Button> */}
              {/* <Typography variant="caption">{log}</Typography> */}
            </Stack>
            {(!UIReady || isLocalhost) && (
              <Box width={'100%'} sx={{ m: 1 }}>
                <LinearProgress color="primary" />
              </Box>
            )}

            {/* <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                OR
              </Typography>
            </Divider> */}

            {/* <LoginForm /> */}
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
